import React from 'react';
import { Phone } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';
import SEO from '../components/SEO';

function Klantenservice() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
       <SEO
        title="Klantenservice - elektricieninarnhem026.nl"
        description="Hulp nodig? Onze klantenservice is de snelste manier om hulp te krijgen. Je vindt hier antwoorden op de meest gestelde vragen en kunt ook per onderwerp zoeken."
        image="/images/banner.png"
      />
      <Header />

      {/* Hero Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
        <h1 className="font-bold text-black leading-[1.25] text-[40px] lg:text-[52px] mb-4 text-[28px] md:mb-5 md:text-[44px] text-[#17354A]">
          Hulp nodig?
        </h1>
        <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] font-medium max-w-[100%] md:max-w-[62.5%]">
          Op zoek naar een antwoord? Onze klantenservice is de snelste manier om hulp te krijgen. Je vindt hier antwoorden op de meest gestelde vragen en kunt ook per onderwerp zoeken. Kom je er toch niet uit? Dan staan we natuurlijk voor je klaar!
        </div>
      </section>

      {/* Quick Links */}
      {/* <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] grid lg:grid-cols-3 gap-3 mb-16 md:auto-cols-fr md:grid-flow-col md:mb-32 md:gap-5">
        {[
          {
            title: 'Hoe we factureren',
            image: ''
          },
         
        ].map((item, index) => (
          <a 
            key={index}
            href="#" 
            className="group flex relative h-[100px] items-center border border-solid border-[#E5E7EB] rounded-xl overflow-hidden transition-colors duration-150 hover:border-[#5EBFCE] hover:text-[#5EBFCE]"
          >
            <img
              alt=""
              loading="lazy"
              width="77"
              height="100"
              className="mr-5"
              src={item.image}
            />
            <div className="text-[18px] md:text-[20px] font-medium group-hover:text-[#5EBFCE] text-[#17354A] transition-colors duration-150">
              {item.title}
            </div>
            <div className="w-[20px] ml-6 flex items-center h-full">
              <ChevronRight className="absolute right-4 text-inherit text-gray-300 group-hover:text-[#5EBFCE] transition-colors duration-150" />
            </div>
          </a>
        ))}
      </section> */}

      {/* FAQ Categories */}
      {/* <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-16 md:mb-[120px]">
        <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] mb-4 text-[24px] md:mb-5 md:text-[36px] text-[#17354A]">
          Antwoord op je vragen
        </h2>
        <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] max-w-[560px] mb-8 md:mb-12">
          We hebben alle belangrijke onderwerpen voor je op een rij gezet. Zo vind je snel de juiste antwoorden op je vragen.
        </div>
        <div className="grid gap-x-8 gap-y-4 md:gap-y-5 md:grid-cols-[1fr_1fr]">
          {[
            {
              title: 'Hoe werken wij',
              description: 'Over dynamische energie, marktprijzen en factureren'
            },
            {
              title: 'Slim Laden',
              description: 'Hoe het werkt en wat het je oplevert'
            },
            {
              title: 'Offerte aanvragen',
              description: 'Overstappen, spoedaanmelding doen en welkomstkorting'
            },
            {
              title: 'Slimme elektrotechnische oplossingen',
              description: 'Hoe het werkt en wat het je oplevert'
            }
          ].map((item, index) => (
            <a 
              key={index}
              className="px-5 py-6 md:px-8 md:py-8 border border-[#E5E7EB] rounded-xl w-full flex flex-row justify-between items-center hover:border-gray-400 group transition-all ease-out duration-500"
              href="#"
            >
              <div className="flex flex-col w-full gap-1">
                <span className="text-[18px] md:text-[20px] font-medium text-[#17354A]">
                  {item.title}
                </span>
                <span className="text-[16px] font-normal text-gray-500">
                  {item.description}
                </span>
              </div>
              <ChevronRight className="text-gray-200 group-hover:text-[#17354A] transition-all ease-out duration-500" />
            </a>
          ))}
        </div>
      </section> */}

      {/* Contact Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px]">
        <div className="max-w-[1088px] mx-auto mb-16 md:mb-[120px]" id="contact">
          <h3 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[24px] md:text-[36px] text-[#17354A] mb-4 md:mb-5">
            Contact
          </h3>
         
          <div className="grid gap-3 md:grid-cols-2 md:gap-5">
            {[
              {
                title: 'Whatsapp',
                description: 'Voor snelle, korte vragen kun je met ons chatten.',
                phone: '+31 6 30535343',
                hours: 'Ma. - vr. van 09:00 tot 17:00',
                hasAlert: true
              },
              {
                title: 'Bellen',
                description: 'Heb je direct antwoord nodig op je vraag?',
                phone: '085-2129778',
                hours: 'Ma. - vr. van 09:00 tot 15:00',
                hasAlert: true
              }
            ].map((item, index) => (
              <div key={index} className="py-7 px-5 rounded-xl border border-[#E5E7EB] md:px-8 md:py-8">
                <div className="flex justify-between items-center">
                  <div className="font-medium flex gap-2 mb-2 text-[18px] md:text-[20px] text-[#17354A]">
                    {item.title}
                    {item.hasAlert && (
                      <div className="flex justify-center place-items-center">
                        <span className="bg-red-500 h-[6px] w-[6px] rounded-md md:h-2 md:w-2 md:rounded-lg" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-[16px] md:text-[18px]">
                  <p className="text-[#17354A]">{item.description}</p>
                  <div className="flex mt-5 md:mt-6 gap-2 text-[#17354A]">
                    <div>
                      <Phone className="w-7 h-7" />
                    </div>
                    <div className="flex flex-col">
                      <div className="text-[18px] md:text-[20px] text-[#17354A] font-medium hover:underline cursor-pointer">
                        {item.phone}
                      </div>
                      <div className="text-[16px] md:text-[18px] text-[#17354A]">
                        {item.hours}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Klantenservice;